<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'900px'"
    :classDialog="'dialogTransferHandling'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">
          Chọn ban lãnh đạo
        </h2>
      </div>
      <!-- body -->

      <el-row class="dialog-body margin-0" :gutter="24">
        <el-col :span="12" class="list-collapse__transfer">
          <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
            <el-tree
              :data="bans"
              show-checkbox
              default-expand-all
              node-key="id"
              ref="tree"
              highlight-current
              :default-checked-keys="defaultCheckedKeys"
              @check-change="checkChangeHandler">
            </el-tree>
          </VuePerfectScrollbar>
        </el-col>
        <el-col :span="12" class="display-list__selected">
          <!-- chuyen xu ly -->
          <div :class="['list-selected']">
            <!-- title -->
            <div class="header">
              <div class="flex-row flex__between">
                <h5 class="title margin-0">Danh sách đã chọn</h5>
              </div>
            </div>
            <!-- end_title -->
            <div class="body">
              <div class="list-filter">
                <VuePerfectScrollbar
                  class="scroll-list-user"
                  :settings="perfectScrollbarSetting"
                >
                  <div
                    v-for="(item, index) in selectedData"
                    :key="index"
                    class="selected-user flex-row flex__between"
                  >
                    <div class="title flex-row flex__left padding-right-10">
                      <div class="clickable margin-right-10">
                        {{ index + 1 }}.
                      </div>
                      <div
                        class="flex-row flex__left"
                      >
                        <div class="info">
                          <p class="people__name">
                            {{ item.label }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="list-checkbox flex-row flex__right margin-right-10"
                    >
                      <i
                        class="icon-close color__red clickable font-size__medium el-icon-circle-close"
                        @click="removeSelectedData(item)"
                      ></i>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="submit"
        >
          <i :class="['fas fa-check-circle font-size__small']"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import CustomDialog from "../../common/custom-dialog";

  export default {
    name: "lichtuan-select-banlanhdao-dialog",
    props: [
      "isOpen",
      "selectedItems"
    ],
    components: {
      CustomDialog,
      VuePerfectScrollbar
    },

    data() {
      return {
        bans: [],

        settings: {maxScrollbarLength: 750},
        selectedData: [],
        defaultCheckedKeys: []
      };
    },

    computed: {
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },
    },

    created() {
      this.initTreeNode();
    },

    methods: {
      initTreeNode() {
        const hdtvNode = {
          id: 'hdtv',
          label: 'Hội đồng thành viên'
        };

        const btgdNode = {
          id: 'btgd',
          label: 'Ban Tổng giám đốc'
        }

        const ldtctNode = {
          id: 'ldtct',
          label: 'Lãnh đạo TCT',
          children: [hdtvNode, btgdNode]
        };

        this.bans = [ldtctNode];

        this.defaultCheckedKeys = this.selectedItems;
        if (this.selectedItems.includes('ldtct')) {
          this.selectedData.push(ldtctNode);
        } else {
          this.selectedItems.includes("hdtv") && this.selectedData.push(hdtvNode);
          this.selectedItems.includes("btgd") && this.selectedData.push(btgdNode);
        }
      },

      removeSelectedData(item) {
        this.selectedData.splice(this.selectedData.indexOf(item), 1);
        this.$refs.tree.setChecked(item, false, true);
      },

      checkChangeHandler() {
        const checkedKeys = this.$refs.tree.getCheckedKeys();
        const checkedNodes = this.$refs.tree.getCheckedNodes();

        this.selectedData = [];
        if (checkedKeys.includes('ldtct')) {
          this.selectedData = [];
          const ldtctNode = this.$refs.tree.getNode('ldtct');
          ldtctNode && this.selectedData.push(ldtctNode.data);
        } else if (checkedKeys.length > 0) {
          this.selectedData.push(...checkedNodes)
        }
      },

      submit() {
        this.$emit("changed", {selectedData: this.selectedData});
      }
    }
  };
</script>
<style scoped>
  .title {
    width: 100%;
  }

  .list-checkbox {
    position: relative;
    margin-right: 10px;
  }

  .scroll-list-user {
    height: auto;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  .list-checkbox .item {
    width: 90px;
    text-align: center;
    margin: 0;
  }

  .icon-close {
    position: absolute;
    right: -5px;
    font-size: 18px;
  }

  .dialog-body .display-list__selected .list-selected .header > div {
    width: 100%;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .dialogTransferHandling .dialog-body .list-collapse__transfer {
    display: flex;
    flex-direction: column;
  }

  .dialogTransferHandling .dialog-body .scroll-area-height_90 {
    height: 100%;
    margin-bottom: 0;
    margin-right: -13px;
  }

  .dialog-body .display-list__selected {
    height: 400px;
  }

  .dialogTransferHandling .dialog-body .display-list__selected .list-selected {
    height: 385px;
  }

  .dialog-body .display-list__selected .list-selected .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .dialog-body .display-list__selected .list-selected .body .list-filter {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/lichtuan-select-banlanhdao-dialog.vue